<template>
   <v-list class="menuLinks">
      <v-list-item-group v-model="selectedItem" mandatory v-if="role.planner">
         <router-link v-for="route in links" :to="routeTo(route)" :key="route.id">
            <v-tooltip color="primary" right :disabled="isDisabled">
               <template v-slot:activator="{ on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                     <v-icon color="primary">{{ route.icon }}</v-icon>
                     <span class="d-inline-block menu-item-link">{{ route.text }}</span>
                     <span
                        class="notificationBaloon"
                        v-if="newTasks.length && route.text == 'Tarefas e Avisos'"
                     >
                        {{ newTasks.length }}
                     </span>
                  </v-list-item>
               </template>
               <span>{{ route.text }}</span>
            </v-tooltip>
         </router-link>
      </v-list-item-group>
      <v-list-item-group v-model="selectedItem" mandatory v-else>
         <router-link
            v-for="route in links"
            :to="{
               name: route.name
            }"
            :key="route.id"
            :data-v-tour="route.name == 'fluxo-futuro' ? 'tour-categorization-final' : ''"
         >
            <v-tooltip color="primary" right :disabled="isDisabled">
               <template v-slot:activator="{ on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                     <v-icon color="primary">{{ route.icon }}</v-icon>
                     <span class="d-inline-block menu-item-link">{{ route.text }}</span>
                     <span
                        class="notificationBaloon"
                        v-if="newTasks.length && route.text == 'Tarefas e Avisos'"
                     >
                        {{ newTasks.length }}
                     </span>
                  </v-list-item>
               </template>
               <span>{{ route.text }}</span>
            </v-tooltip>
         </router-link>
      </v-list-item-group>
   </v-list>
</template>

<script>
import activeMenuIndex from "../../helpers/active-menu-index";
import { mapGetters } from "vuex";

export default {
   name: "MenuLinks",
   data() {
      return {
         selectedItem: null
      };
   },
   computed: {
      ...mapGetters(["myTasks", "role"]),
      newTasks() {
         return this.myTasks.filter(task => task.status == "pending");
      },

      clientId() {
         const ID =
            this.$route.params.clientId ||
            this.$route.query.clientId ||
            this.$route.query.client ||
            this.$route.params.client;

         if (!ID || ["null", "undefined"].includes(String(ID))) {
            return null;
         }

         return String(ID);
      },

      isDisabled() {
         return this.$vuetify.breakpoint.width >= 1366;
      }
   },
   methods: {
      routeTo(route) {
         const to = { name: route.name };

         if (this.clientId) {
            to.params = { clientId: this.clientId };
            to.query = { clientId: this.clientId };
         }

         return to;
      },

      updateMenuActive(newRoute = {}) {
         this.selectedItem = activeMenuIndex({
            route: newRoute,
            list: this.links
         });
      }
   },
   props: {
      links: {
         type: Array,
         required: true
      }
   },
   watch: {
      $route: {
         handler(newRoute) {
            this.updateMenuActive(newRoute);
         },
         immediate: true
      }
   }
};
</script>
